export default __webpack_public_path__ + "static/media/service-background.3938ce7b.png";